import React, { useState } from 'react'
import axios from 'axios'
import { baseApiURL } from 'src/utils/utils.ts'
import styles from './frontpage.module.scss'
import Input from 'src/components/input/Input'
import Button from 'src/components/button/Button'
import { useHistory, useParams } from 'react-router'
import { ParamTypes } from 'src/Interface'
import { validPassword, resetError, handleInputChange, handleValidation } from 'src/utils/utils'
import { toast } from 'react-toastify'

interface IValues {
  password: string
  confirmPassword: string
}

interface IErrors {
  password: boolean
  confirmPassword: boolean
}

const NewPassword: React.FunctionComponent = () => {
  const { resetKey } = useParams<ParamTypes>()
  const [isLoading, setIsLoading] = useState(false)
  const history = useHistory()
  const [conflictingCredentials, setConflictingCredentials] = useState(false)
  const [errors, setErrors] = useState<IErrors>({
    password: false,
    confirmPassword: false
  })
  const [values, setValues] = useState<IValues>({
    password: '',
    confirmPassword: ''
  })

  const setNewPassword = (e) => {
    e.preventDefault();
    if (values.confirmPassword === values.password) {
      setIsLoading(true)
      axios.put(`${baseApiURL()}/users/new_password`,
        {
          password: values.password,
          confirmPassword: values.confirmPassword,
          resetKey
        }).then(() => {
          setIsLoading(false)
          toast('Oprettet nyt kodeord')
          history.push('/login')
        }).catch((err) => {
          setIsLoading(false)
          toast(err.response.data.message)
          setErrors({
            ...errors,
            confirmPassword: true,
            password: true
          })
        })
    } else {
      setConflictingCredentials(true)
    }
  }

  return (
    <div className={styles.module}>
      <form onSubmit={setNewPassword}>
        <Input
          name='password'
          label='Kodeord'
          error={conflictingCredentials || errors.password}
          placeholder='Indtast dit kodeord'
          type='password'
          resetError={() => resetError('password', setErrors, errors, setConflictingCredentials)}
          handleInputChange={() => handleInputChange('password', setValues, values)}
          handleValidation={() => handleValidation(validPassword, 'password', setErrors, errors)}
        />

        <Input
          name='confirmPassword'
          label='Gentag kodeord'
          error={conflictingCredentials || errors.confirmPassword}
          placeholder='Indtast dit kodeord'
          legalText='Kodeord skal indeholde 12 tegn.'
          type='password'
          resetError={() => resetError('confirmPassword', setErrors, errors, setConflictingCredentials)}
          handleInputChange={() => handleInputChange('confirmPassword', setValues, values)}
          handleValidation={() => handleValidation(validPassword, 'confirmPassword', setErrors, errors)}
        />
        {errors.confirmPassword && <p className='errorMsg'>Kodeord ser ikke ud til at være i et korrekt format.</p>}
        {conflictingCredentials && <p className='errorMsg'>Adgangskoden stemmer ikke overens</p>}
        <Button
          label='Opret profil'
          type='primary'
          submit={true}
          loading={isLoading}
          modifiers='mt-5 tw-w-full tw-justify-center'
          disabled={!(values.password && values.confirmPassword) || (errors.password || errors.confirmPassword)}
        />
      </form>
    </div>
  )
}

export default NewPassword